/* EditorSectionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EditorSectionRenderer");
const EditorLayout = require("@gluenetworks/editor_layout");
const LmrbEditorLayout = require("./lmrbcomponents/editor/EditorLmrbComponent");
const LmrbLayout = require("@gluenetworks/lmrb_layout");
const _ = require("lodash");
_.mixin(require("underscore.string").exports());

const EDITOR_LMRB_NAMESPACE = `LmrbComponents.LmrbEditorLayout`;

class EditorSectionComponent extends EventEmitter {
    constructor(di, logger, registeredDetails) {
        super();
        //This is created for us by the Steve Core Section Router and will be destroyed when the user routes away
        this._di = di;
        this._logger = logger;

        this._sectionName = registeredDetails.name;
        this._sectionNamespace = registeredDetails.namespace;

        this._editorLayout = this._di.create(EditorLayout);
        this._di.registry.register(`EditorLayout.EditorLayout`, this._editorLayout);

        //Seed the Editor LMRB Layout
        this._di.registry.register(EDITOR_LMRB_NAMESPACE, LmrbEditorLayout);

        this._lmrbLayout = this._di.create(LmrbLayout);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._di = undefined;
            this._logger = undefined;
        });
    }

    setLmrbNamespaces(namespaces) {
        //make sure the editor lmrb layout is seeded...
        namespaces.push(EDITOR_LMRB_NAMESPACE);
        this._lmrbLayout.setNamespaceGlobs(namespaces);
    }

    setEditorNamespaces(namespaces) {
        this._editorLayout.closeAllEditors();
        this._editorLayout.setNamespaceGlobs(namespaces);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = EditorSectionComponent;
